import $ from 'jquery';

let mixer_detail_list = "";
let mixer_configuration = "";
let control_configuration = "";
let selected_options = [];

// 0:"p85"
// 1:"P85"
// 2:"http://proallinc.localhost/app/uploads/2022/06/mixers_overview_model_P85_SideView_1440x702-300x146.jpg"
// 3:"Production Capacity (m³/yd³)"
// 4:"7.6m³ / 10yd³"
// 5:"Production Rate (m³/hr) (yd³/hr)"
// 6:"<p>The P85 is ProAll’s mid-range model dynamo, perfectly configured for high-volume production capacity and ready for a range of specialist applications. The ProAll P85 promises a more capable, more precise and more responsive mixing experience anywhere, every time.</p>\n"
// 7:"http://proallinc.localhost/app/uploads/2022/06/Marketing-Slick-P85.pdf"


// Next Buttons
$('.step-1-next-button').on('click', function (e) {
  e.preventDefault();
  /**
   * Print and Save Selected Option
   */
  mixer_detail_list = $('input[name="mixer-size"]:checked').val().split('*');
  console.log(mixer_detail_list);

  // Advancing Progress Bar
  $('.progress').addClass('progress-25').removeClass('progress-00');

  // Updating highlighted step
  $('.current').removeClass('current');
  $('.page-2').addClass('current');

  // Switching steps
  $('.step-1').hide();
  $('.step-2').show();
  location.href = "#";
  location.href = "#main-content";

});

$('.step-2-next-button').on('click', function (e) {
  e.preventDefault();
  /**
   * Print and Save Selected Option
   */
  mixer_configuration = $('input[name="mixer-configuration"]:checked').val();
  console.log(mixer_configuration)

  // Advancing Progress Bar
  $('.progress').addClass('progress-50').removeClass('progress-25');

  // Updating highlighted step
  $('.current').removeClass('current');
  $('.page-3').addClass('current');

  // Switching steps
  $('.step-2').hide();
  $('.step-3').show();
  location.href = "#";
  location.href = "#main-content";

});

$('.step-3-next-button').on('click', function (e) {
  e.preventDefault();
  /**
   * Print and Save Selected Option
   */
  control_configuration = $('input[name="control-configuration"]:checked').val();
  console.log(control_configuration)
  // Advancing Progress Bar
  $('.progress').addClass('progress-75').removeClass('progress-50');

  // Updating highlighted step
  $('.current').removeClass('current');
  $('.page-4').addClass('current');

  // Switching steps
  $('.step-3').hide();
  $('.step-4').show();
  location.href = "#";
  location.href = "#main-content";

});

$('.step-4-next-button').on('click', function (e) {
  e.preventDefault();
  /**
   * Print and Save Selected Option
   */
  $('input[name="mixer-option"]:checked').each(function (index, element) {
    selected_options.push(element.value)
  });
  console.log(selected_options)

  // Advancing Progress Bar
  $('.progress').addClass('progress-100').removeClass('progress-75');

  // Updating highlighted step
  $('.current').removeClass('current');
  $('.page-5').addClass('current');

  // Switching steps
  $('.step-4').hide();
  $('.step-5').show();
  location.href = "#";
  location.href = "#main-content";


//  Populate review page
  $('#mixer-sideview-image').attr('src', mixer_detail_list[2]);
  $('#mixer-name').text(mixer_detail_list[1]);
  $('#mixer-spec-1-name').text(mixer_detail_list[3]);
  $('#mixer-spec-1-value').text(mixer_detail_list[4]);
  $('#mixer-spec-2-name').text(mixer_detail_list[5]);
  $('#mixer-spec-2-value').text(mixer_detail_list[6]);
  $('#mixer-excerpt').html(mixer_detail_list[7]);
  $('#mixer-pdf').attr('href', mixer_detail_list[8]);

  $('#mixer-size-value').text(mixer_detail_list[1]);
  $('#mixer-configuration-value').text(mixer_configuration);
  $('#mixer-control-value').text(control_configuration);

  let additional_options_html = "";
  selected_options.forEach(function (value) {
    additional_options_html += '<li>' + value + '</li>'
  })

  $('#mixer-additional-options').html(additional_options_html);
});

// Prev Buttons
$('.step-2-prev-button').on('click', function (e) {
  e.preventDefault();

  // Advancing Progress Bar
  $('.progress').addClass('progress-00').removeClass('progress-25');

  // Updating highlighted step
  $('.current').removeClass('current');
  $('.page-1').addClass('current');

  // Switching steps
  $('.step-2').hide();
  $('.step-1').show();
  location.href = "#";
  location.href = "#main-content";
});

$('.step-3-prev-button').on('click', function (e) {
  e.preventDefault();

  // Advancing Progress Bar
  $('.progress').addClass('progress-25').removeClass('progress-50');

  // Updating highlighted step
  $('.current').removeClass('current');
  $('.page-2').addClass('current');

  // Switching steps
  $('.step-3').hide();
  $('.step-2').show();
  location.href = "#";
  location.href = "#main-content";
});

$('.step-4-prev-button').on('click', function (e) {
  e.preventDefault();

  // Advancing Progress Bar
  $('.progress').addClass('progress-50').removeClass('progress-75');

  // Updating highlighted step
  $('.current').removeClass('current');
  $('.page-3').addClass('current');

  // Switching steps
  $('.step-4').hide();
  $('.step-3').show();
  location.href = "#";
  location.href = "#main-content";
});

$('.step-5-prev-button').on('click', function (e) {
  e.preventDefault();

  // Advancing Progress Bar
  $('.progress').addClass('progress-75').removeClass('progress-100');

  // Updating highlighted step
  $('.current').removeClass('current');
  $('.page-4').addClass('current');

  // Switching steps
  $('.step-5').hide();
  $('.step-4').show();
  location.href = "#";
  location.href = "#main-content";
});
